class LqdCountdownHandler extends elementorModules.frontend.handlers.Base {

  onInit(...args) {

    super.onInit(...args);

    this.handleDestroy();

    this.initCountdown();

  }

  getDefaultSettings() {
    return {
      selectors: {
        countdownElement: '[data-plugin-countdown]',
      }
    }
  }

  getDefaultElements() {
    const selectors = this.getSettings('selectors');
    return {
      $countdownElement: this.$element.find(selectors.countdownElement),
    }
  }

  initCountdown() {

    this.elements.$countdownElement.liquidCountdown();

  }

  onDestroy() {

    this.handleDestroy();

    super.onDestroy();

  }

  handleDestroy() {

    this.handleCountdownDestroy();

  }

  handleCountdownDestroy() {

    if ( ! this.elements.$countdownElement.length ) return;

    const countdownData = this.elements.$countdownElement.data('plugin_liquidCountdown');

    if ( countdownData ) {
      countdownData.destroy();
    }

  }
  
}

export default ($element) => {
  elementorFrontend.elementsHandler.addHandler( LqdCountdownHandler, { $element } );
};